import React from 'react';
import { Button, Text, Img, Icon, DatePicker } from '../../Atoms';
import { Upload, Input } from '../../Molecules';

const SubmitForm = ({
                      selectFile,
                      onChange,
                      description,
                      isDescriptionValid,
                      isUploadValid,
                      type,
                      seuil,
                      onSubmit
               }) => {
  return (
    <div style={{ paddingBottom: '30px' }}>
      <Upload
        handleFileChange={selectFile}
        errorMsg="Attention : merci de bien vouloir nous joindre votre document."
        isUploadValid={isUploadValid}
      />
      <Input
        placeholder="Laissez-nous un message qui décrit votre besoin (obligatoire)"
        className="input-decription-document"
        onChange={(e) => onChange(e)}
        as="textarea"
        value={description}
        errorMessage="Attention : merci de bien vouloir joindre un message à votre envoi."
        isInvalid={!isDescriptionValid}
      />
      <div className="container-btn-send-doc">
        <Button
          disabled={
            !isUploadValid ||
            !isDescriptionValid ||
            (type?.name == 'FACTURE' && seuil === 0)
          }
          text="Envoyer"
          className="btn-send-doc"
          onClick={() => onSubmit()}
          resetHover={true}
        />
      </div>
    </div>
  );
};

export default SubmitForm;